export function GoldUpgradeCtrl ($uibModalInstance, $scope, sessionObjAPI, workshopAPI) {
  $scope.session = sessionObjAPI.base();

  $scope.confirm = function () {
    return workshopAPI.get('/company/convert_to_workshop_gold_from_silver')
      .then(function (data) {
        return $uibModalInstance.close(data);
      }, function (err) {
        return $uibModalInstance.dismiss(err);
      });
  }
};